import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PageHeader from '../components/PageHeader.jsx';
import GoogleCalendarCard from '../components/GoogleCalendarCard.jsx';
import CalComCard from '../components/CalComCard.jsx';

// Exec-assistant INTEGRATIONS page. Home for the Google Calendar connect flow, and
// the landing spot the Google OAuth callback redirects back to
// (/settings/integrations?calendar=connected|error|denied). We read that param,
// show a one-time banner, strip it from the URL, and bump refreshKey so the card
// re-fetches its (now connected) status.
const CALENDAR_MSG = {
  connected: { tone: 'ok', text: 'Google Calendar connected.' },
  error: { tone: 'err', text: "Couldn't connect Google Calendar. Please try again." },
  denied: { tone: 'err', text: 'Google Calendar access was declined.' }
};

export default function IntegrationsSettings() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [banner, setBanner] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const result = searchParams.get('calendar');
    if (!result) return;
    setBanner(CALENDAR_MSG[result] || null);
    setRefreshKey((k) => k + 1); // re-fetch the card's status after the redirect
    // Strip the param so a refresh doesn't re-show the banner.
    const next = new URLSearchParams(searchParams);
    next.delete('calendar');
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <div className="px-6 md:px-10 py-8 max-w-3xl">
      <PageHeader
        title="Integrations"
        subtitle="Connect the tools your assistant works with."
      />

      {banner && (
        <p className={`mb-6 rounded-lg border px-4 py-2 text-sm ${
          banner.tone === 'ok'
            ? 'border-emerald-800/50 bg-emerald-950/30 text-emerald-200'
            : 'border-red-500/40 bg-red-500/10 text-red-200'
        }`}>
          {banner.text}
        </p>
      )}

      <GoogleCalendarCard refreshKey={refreshKey} />
      <CalComCard refreshKey={refreshKey} />
    </div>
  );
}
